// lib/messages.js
import supabase from "../supabase";

/** List inbox (newest first), scoped to the active org */
export async function listInbox(org_id) {
  // 🚨 CRITICAL: Always require an org_id to prevent cross-org leaks
  if (!org_id) return [];

  const { data, error } = await supabase
    .from("messages")
    .select(
      "id, org_id, from_user, to_user, project_id, article_id, subject, body, type, status, created_at"
    )
    .eq("org_id", org_id) // ✅ Lock to Tenant
    .order("created_at", { ascending: false });
  if (error) throw error;
  return data || [];
}

/** Mark a message read */
export async function markRead(id) {
  const { error } = await supabase
    .from("messages")
    .update({ status: "read" })
    .eq("id", id);
  if (error) throw error;
}

/** Send a direct message inside the active org */
export async function sendDirectMessage({ to_user, subject, body }, org_id) {
  // org_id is the currently active org (not necessarily the sender's home
  // org_id — a superAdmin may be composing while impersonating another org)
  if (!org_id) throw new Error("Missing org_id");

  const from_user = (await supabase.auth.getUser()).data.user.id;

  const { error } = await supabase
    .from("messages")
    .insert([{ org_id, from_user, to_user, type: "direct", subject, body }]);
  if (error) throw error;
}

export async function deleteMessage(messageId) {
  const { error } = await supabase
    .from("messages")
    .delete()
    .eq("id", messageId); // RLS ensures only recipient can delete

  if (error) throw error;
}
